import React from "react";
import dayjs from "dayjs";
import "dayjs/locale/es";
dayjs.locale("es");

const CalendarioSemanal = ({ interacciones, mes }) => {

    // const dias = interacciones.map((key) => ({
    //     dia: key,
    //     ...interacciones[key],
    // }));


    // console.log(dias)
    // Info del primer día
    const primerDia = dayjs(`2025-${mes}-${interacciones[0].dia}`); // Ajusta año/mes dinámicamente
    const offset = primerDia.day(); // 0 = domingo, 1 = lunes, etc.

    // // Creamos un array con huecos al inicio
    const calendario = [
        ...Array(offset).fill(null), // Huecos antes del primer día
        ...interacciones,
    ];

    // Rellenar hasta múltiplo de 7
    while (calendario.length % 7 !== 0) {
        calendario.push(null);
    }

    console.log(mes)
    console.log(interacciones)
    // console.log(calendario)

    return (
        <div className="row row-cols-7 g-2">
            {["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"].map((d, i) => (
                <div key={i} className="fw-bold text-center border p-1 bg-secondary text-white"
                    style={{ flex: "0 0 calc(100% / 7)" }}
                >
                    {d}
                </div>
            ))}

            {calendario.map((item, idx) => (
                <div key={idx} className="border shadow-sm  pb-1  text-center"
                    style={{ flex: "0 0 calc(100% / 7)" }}
                >
                    {item ? (
                        <div className="position-relative">
                            <p className="m-0 text-start  position-absolute top-0 bg-secondary text-white fw-semibold px-2" style={{ left: "0", fontSize: "14px" }}>{item.dia}</p>
                            <div className="d-flex ">
                                <small className={`fw-bold ${item?.total == 0 ? 'text-danger' : 'text-primary'}`} style={{ fontSize: "2rem", width: "60%",  paddingTop:"20px" }}>{item.total}</small>
                                <div className="d-flex flex-column  gap-2 align-items-start " style={{ width: "40%" }}>
                                    <div className="d-flex flex-column    align-items-start">
                                        <p className="m-0 fw-bold" style={{ fontSize: "10px", color: "#1134C9" }} >MVD: <span>{item.interacciones_mvd}</span></p>
                                        <div className="d-flex  gap-2 justify-content-center">
                                            <p className="m-0 text-success fw-medium" style={{ fontSize: "10px" }}>{item.mvd_aprobadas}</p>
                                            <p className="m-0 text-danger fw-medium" style={{ fontSize: "10px" }}>{item.mvd_anuladas}</p>
                                        </div>
                                    </div>

                                    <div className="d-flex flex-column  align-items-start">
                                        <p className="m-0 fw-bold" style={{ fontSize: "10px" }}>Office: {item.aprobadas_backoffice + item.anuladas_backoffice}</p>
                                        <div className="d-flex  gap-2">
                                            <p className="m-0 text-success fw-medium" style={{ fontSize: "10px" }}>{item.aprobadas_backoffice}</p>
                                            <p className="m-0 text-danger fw-medium" style={{ fontSize: "10px" }}>{item.anuladas_backoffice}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        ""
                    )}
                </div>
            ))}
        </div>
    )
}

export default CalendarioSemanal;